import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoutIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 47,
	viewBox: "0 0 43 47",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25.891,
			cy: 29.7727,
			rx: 3.76599,
			ry: 3.65553,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 21,
			cy: 26.2958,
			rx: 17,
			ry: 16.8935,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 39.5318,
			cy: 39.1658,
			rx: 2.53176,
			ry: 2.61109,
			fill: "#FC6B6B"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.0127,
			cy: 45.9546,
			rx: 1.0127,
			ry: 1.04444,
			fill: "#E34C4C"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.0127,
			cy: 1.04444,
			rx: 1.0127,
			ry: 1.04444,
			fill: "#FC6B6B"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 23.5,
			cy: 7.83375,
			rx: 2.5,
			ry: 2.61109,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 45C28.9 45 37 36.9 37 27C37 17.1 28.9 9 19 9C9.1 9 1 17.1 1 27C1 36.9 9.1 45 19 45Z",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5625 29.62L11.0025 27.06L13.5625 24.5",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2422 27.0596H11.0722",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2422 35C23.6622 35 27.2422 32 27.2422 27C27.2422 22 23.6622 19 19.2422 19",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgLogoutIcon;
